import { Agent, fetch } from 'undici'
import ProxyHttpRequest from '../interfaces/proxy-http-request.js'
import { GigyaResponse } from '../rba.js'

let certificate: string
let verboseHttpError = process.env['GIGYA_VERBOSE_HTTP_LOGGING']

function log(msg: any): void {
	if (verboseHttpError) {
		console.log(msg)
	}
}

export const httpMethod = 'post'

/**
 * Make HTTP request to Gigya.
 */
export const httpRequest: ProxyHttpRequest = <R>(
	endpoint: string,
	host: string,
	requestParams: any,
	headers?: HeadersInit,
	agent?: Agent
) => {
	const uri = `https://${host}/${endpoint}`

	return fetch(uri, {
		method: 'post',
		headers,
		body: new URLSearchParams(requestParams),
		dispatcher: agent
	}).then((r) => r.json() as unknown as GigyaResponse & R)
}

export default httpRequest
